<template>
  <v-row justify="center" align="center" class="my-6 px-4">
    <v-col cols="12" sm="4" class="py-0 pb-4 pb-sm-0">
      <slot name="empresa"></slot>
    </v-col>

    <v-col cols="12" sm="4" class="py-0">
      <slot name="sucursal"></slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FiltrarEmpleadosRetirados',
};
</script>
